import { handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import { GET_OFFER_PACKAGE } from '../actions/offer-actions';

const { REQUEST, SUCCESS, FAILURE } = httpActions;

export const initialState = {
  offerPackagesByApplicationUuid: {
    // 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   applicationUuid: '',
    //   creditUnion: '',
    //   declineReasons: [''],
    //   decision: 'INITIAL|SELECT|FINAL',
    //   disabledIncomeSources: [''],
    //   incomeResultRecordUuids: [''],
    //   incomeRequestRecords: [''],
    //   plaidItemUuids: [''],
    //   hasMultipleOriginationFees: false,
    //   offersByType: [
    //     {
    //       min: undefined, // number
    //       max: undefined, // number
    //       offers: [
    //         {
    //           index: 0,
    //           id: '', // compound tier + term
    //           baseRate: 0,
    //           rateWithDiscounts: 0,
    //           term: 0,
    //           min: 0,
    //           max: 0,
    //           rateType: 'FIXED'
    //           originationFeePercentage: 0,
    //           discountList: [
    //             {
    //               discount: { type: '', amount: 0 },
    //               rateWithDiscount: 0,
    //             }
    //           ]
    //         }
    //         ...
    //       ]
    //       rateType: 'FIXED',
    //       termsList: [],
    //     },
    //     ...
    //   ],
    //   plaidItemUuids: [''],
    //   statedTotalIncome: 0,
    //   subDecision: '',
    //   verifiedIncomeRequestUuid: '',
    //   verifiedTotalIncome: 0,
    // }
  },
  loading: false,
};

// TODO: move to util

function parseOffersMinMax(offers = []) {
  const reduce = (accValue, value, mathTask) =>
    typeof accValue === 'undefined' ? value : mathTask(accValue, value);

  return offers.reduce(
    (acc, o) => ({
      min: reduce(acc.min, o.min, Math.min),
      max: reduce(acc.max, o.max, Math.max),
    }),
    {
      min: undefined,
      max: undefined,
    }
  );
}
const parseOffersTermsList = (offers) =>
  offers.reduce((termsList, offer) => {
    if (!termsList.includes(offer.term)) termsList.push(offer.term);
    return termsList;
  }, []);

const reducer = handleActions(
  {
    [`${GET_OFFER_PACKAGE}_${REQUEST}`](state = initialState) {
      return {
        ...state,
        loading: true,
      };
    },
    [`${GET_OFFER_PACKAGE}_${SUCCESS}`](state, action) {
      const { applicationUuid, offers } = action.payload;
      const offerPackage = state.offerPackagesByApplicationUuid[applicationUuid] || {};
      const offerTypeMap = {};

      (offers || []).forEach((o) => {
        if (!offerTypeMap[o.rateType]) offerTypeMap[o.rateType] = [];
        offerTypeMap[o.rateType].push(o);
      });

      const offersByType = Object.entries(offerTypeMap).map(([k, v]) => {
        const minMax = parseOffersMinMax(v);
        const termsList = parseOffersTermsList(v);
        const oldOffersByType =
          (offerPackage.offersByType || []).find((ot) => ot.rateType === k) || {};

        return {
          ...oldOffersByType,
          min: minMax.min,
          max: minMax.max,
          offers: v
            .map((o) =>
              Object.assign({}, o, {
                id: `${o.term}-${o.rateType}-${o.min}-${o.max}`,
              })
            )
            // Double check that offers are in lowest-highest index order as this will affect disabled offer logic
            .sort((o1, o2) => o1.index - o2.index),
          rateType: k,
          termsList,
        };
      });

      const minMax = parseOffersMinMax(offers);
      const maxOriginationFeePercentage = offers.reduce(
        (acc, cur) => Math.max(acc, cur.originationFeePercentage),
        0
      );

      return {
        ...state,
        offerPackagesByApplicationUuid: {
          ...state.offerPackagesByApplicationUuid,
          [applicationUuid]: {
            ...offerPackage,
            applicationUuid,
            creditUnion: action.payload.creditUnion,
            decision: action.payload.decision,
            declineReasons: offerPackage.declineReasons || [],
            disabledIncomeSources: action.payload.disabledIncomeSources,
            incomeRequestRecords:
              action.payload.incomeRequestRecords?.map((ir) => ({
                ...ir,
                verificationMethod: ir.methods.find(
                  (m) => m.indexOf('PLAID_') > -1 || m.indexOf('POINTSERV_') > -1
                ),
              })) || [],
            incomeResultRecordUuids: action.payload.incomeResultRecordUuids || [],
            min: minMax.min,
            max: minMax.max,
            hasOriginationFees: maxOriginationFeePercentage > 0,
            offersByType,
            plaidItemUuids: action.payload.plaidItemUuids || [],
            statedTotalIncome: action.payload.statedTotalIncome,
            subDecision: action.payload.subDecision,
            verifiedIncomeRequestUuid: action.payload.verifiedIncomeRequestUuid,
            verifiedTotalIncome: action.payload.verifiedTotalIncome,
          },
        },
        loading: false,
      };
    },
    [`${GET_OFFER_PACKAGE}_${FAILURE}`](state) {
      return {
        ...state,
        loading: false,
      };
    },
  },
  initialState
);

export default reducer;
